import CreditLimit from './views/credit-limit.c';
export default CreditLimit;
